import React from "react";
import { LOGO } from "@/lib/assets";

export function Crest({ className = "h-9 w-9" }) {
  return <img src={LOGO.crest} alt="Simo University crest" className={className} data-testid="simo-crest" />;
}

export function Wordmark({ white = false, className = "h-9" }) {
  return <img src={white ? LOGO.wordmarkWhite : LOGO.wordmarkPurple} alt="Simo University" className={className} data-testid="simo-wordmark" />;
}
